import { gql } from "@apollo/client";

const COMPLETE_SUBSCRIPTION_SETUP = gql`
  mutation completeSubscriptionSetup(
    $customerId: String!
    $setupIntentId: String!
    $priceId: String!
    $noOfAgents: Int!
    $planName: String!
  ) {
    completeSubscriptionSetup(
      customerId: $customerId
      setupIntentId: $setupIntentId
      priceId: $priceId
      noOfAgents: $noOfAgents
      planName: $planName
    ) {
      success
      error
      result
    }
  }
`;

export default COMPLETE_SUBSCRIPTION_SETUP;
